import styled from "vue-styled-components";

export const CDropdownMenuWrapper = styled.div`
    position: relative;
    background-color: ${props => props.theme?.cart?.background_color ?? '#fff'};
    padding: ${props => props.theme?.cart?.padding ?? '2rem'};
    border-radius: ${props => props.theme?.cart?.border_radius ?? '0'};
    border: 1px solid ${props => props.theme?.cart?.external_border_color ?? '#f0f0f0'};
    box-shadow: 0 29px 28px rgba(0, 0, 0, 0.1);


    &:before {
        right: 28px;
        left: auto;
    }

    &:after {
        right: 29px;
        left: auto;
    }

    @media (max-width: 767px) {
        &:before {
            right: 12px;
        }

        &:after {
            right: 13px;
        }
    }

    @media (max-width: 360px) {
        padding: 1rem 1.4rem;
    }
`

export const CDropdownCartHeader = styled.div`
    padding: .7rem 1rem;
    display: flex;
    align-items: flex-end;
    font-size: ${props => props.theme?.cart?.title?.font_size ?? '1.3rem'};
    font-weight: ${props => props.theme?.cart?.title?.font_weight ?? '700'};
    text-transform: ${props => props.theme?.cart?.title?.text_transform ?? 'uppercase'};
    color: ${props => props.theme?.cart?.title?.color ?? '#474747'};
    border-bottom: 1px solid ${props => props.theme?.cart?.internal_border_color ?? '#e6ebee'};
    margin-bottom: 0;
    padding-top: 0;

    > a {
        color: inherit;
        margin-left: auto;
        padding: 0;
        /* font-size: 1.2rem; */
    }
`

export const CDropdownCartProducts = styled.div`
    max-height: calc(100vh - 300px);
    overflow-y: auto;

    /* .product-group {
        border-bottom: 1px solid ${props => props.theme?.cart?.internal_border_color ?? '#e6ebee'};

        .product-details {
            display: flex;
            align-items: center;
            padding: 1.6rem 1rem;

            h2 {
                font-size: ${props => props.theme?.cart?.product_name?.font_size ?? '1.5rem'};
                line-height: 1.4;
                margin-bottom: 0.4rem;

                a {
                    color: ${props => props.theme?.cart?.product_name?.color ?? '#2b2b2d'};
                    text-decoration: none;
                    font-weight: ${props => props.theme?.cart?.product_name?.font_weight ?? '400'};
                    text-transform: ${props => props.theme?.cart?.product_name?.text_transform ?? 'initial'};

                    &:hover {
                        color: ${props => props.theme?.cart?.product_name?.color_hover ?? '#2b2b2d'};
                    }
                }
            }
            span {
                padding: 0;
            }
            figure {
                border: 1px solid #ededed;
            }
        }

        span {
            color: ${props => props.theme?.cart?.product_name?.color ?? '#2b2b2d'};
            font-size: 1.3rem;
            font-weight: 500;
            padding: 0.5rem 1rem;
            display: inline-block;
        }
    }

    .product figure.product-image-container,
    .product-group .product-details figure.product-image-container {
        width: 100%;
        display: flex;
        justify-content: center;

        a.product-image img {
            max-height: 100px;
            object-fit: contain;
        }
    }

    .product {
        border-bottom: 1px solid ${props => props.theme?.cart?.internal_border_color ?? '#e6ebee'};

        .product-details {
            margin-right: 10px;

            h2 {
                font-size: ${props => props.theme?.cart?.product_name?.font_size ?? '1.5rem'};
                line-height: 1.4;
                margin-bottom: 0.4rem;

                a {
                    color: ${props => props.theme?.cart?.product_name?.color ?? '#2b2b2d'};
                    text-decoration: none;
                    font-weight: ${props => props.theme?.cart?.product_name?.font_weight ?? '400'};
                    text-transform: ${props => props.theme?.cart?.product_name?.text_transform ?? 'initial'};

                    &:hover {
                        color: ${props => props.theme?.cart?.product_name?.color_hover ?? '#2b2b2d'};
                    }
                }
            }

            span {
                color: ${props => props.theme?.cart?.product_name?.color ?? '#2b2b2d'};
            }
        }

        figure {
            border: 1px solid #ededed;
        }

    } */
`

const propsCDropdownCart = {
    display: {
        default: 'block',
        type: String
    },
    displayMedia: {
        default: 'none',
        type:String
    }
}

export const CDropdownCart = styled('nav', propsCDropdownCart)`
    position: relative;
    margin-left: -10px;
    > a {
        display: ${props => props.theme?.active_icon_cart === false ? 'none' : props.display};
        background-color: ${props => props.theme?.header?.active_icon_cart_circle === true ? (props.theme?.header?.cart_icon_background_color ?? '#fff') : 'transparent' } ;
        position: relative;
        padding-right: 1rem;//2.4rem
        text-decoration: none;
        width: 45px;
        height: 45px;
        border-radius: 50%;

        > h3 {
            display: ${props => props.theme?.header?.active_icon_cart_circle === true ? 'flex' : 'none'};
            color: ${props => props.theme?.header?.active_icon_cart_circle === true ? (props.theme?.header?.enable_font_color ?? '#fff') : '' } ;
            font-weight: ${props => props.theme?.header?.active_icon_cart_circle === true ? (props.theme?.header?.cart_writing_weight ?? '400') : '' };
            margin-top: -27px;
            font-size: 16.5px;
            margin-left: 50px;
            font-family: ${props => props.theme?.header?.active_icon_cart_circle === true ? (props.theme?.header?.cart_writing_font_family ?? 'Poppins') : '' }; 
        }

        > span {
            display: flex;
            align-items: center;
            justify-content: ${props => props.theme?.header?.active_icon_cart_circle === true ? 'left' : 'center'};
            min-width: 1.6rem;
            height: 1.6rem;
            position: absolute;
            right: ${props => props.theme?.header?.active_icon_cart_circle === true ? '-15.5rem' : '0.5rem'}; //1.9rem
            line-height: 1;
            top: ${props => props.theme?.header?.active_icon_cart_circle === true ? '2.4rem' : '-.5rem'};//-.2rem
            border-radius: 50%;
            padding-bottom: 1px;
            font-size: 1.3rem;
            font-weight: ${props => props.theme?.header?.active_icon_cart_circle === true ? (props.theme?.header?.cart_writing_weight ?? '400') : '' };
            color: ${props => props.theme?.header?.active_icon_cart_circle === true ? (props.theme?.header?.enable_font_color ?? '#fff') : '#fff' } ;
            background-color: ${props => props.theme?.header?.active_icon_cart_circle === true? 'transparent' : '#fa4a4a'};
            width: ${props => props.theme?.header?.active_icon_cart_circle === true? '150px' : '0'};
            font-family: ${props => props.theme?.header?.active_icon_cart_circle === true ? (props.theme?.header?.cart_writing_font_family ?? 'Poppins') : '' };

            @media (max-width: 767px) {
                right: .9rem;
            }
        }

        &:hover {
            text-decoration: none;
        }

        &:focus {
            text-decoration: none;
        }

        i {
            font-size: ${props => props.theme?.header?.active_icon_cart_circle === true? '2rem' : (props.theme?.cart_icon_font_size ?? '3.3rem')};
            color: ${props => props.theme?.cart_icon_color ?? '#393f4f'} ;
            display: block;
            margin: ${props => props.theme?.header?.active_icon_cart_circle === true? (props.theme?.cart_icon_margin) : (props.theme?.cart_icon_margin?? '-10px')};
            &:before {
                margin-left: ${props => props.theme?.header?.active_icon_cart_circle === true? '12px' : '0'};
                margin-right: 0px;
                margin-top: ${props => props.theme?.header?.active_icon_cart_circle === true? '11px' : '0'};
            }
        }

        /* &:before {
            display: inline-block;
            content: '\\e80c';
            font-family: 'porto';
            font-size: 3.3rem;
            line-height: 1;
            margin: 2px 0 0;
            color: ${props => props.theme?.cart_icon_color ?? '#393f4f'} ;
        } */

        &:after {
            display: ${props => props.theme?.header?.active_icon_cart_circle === true? 'none' : 'inline-block'};
            position: absolute;
            top: 1rem;
            right: 0;//7px
            width: auto;
            height: auto;
            margin: 0;
            transition: all .3s;
            border: 0;
            color: ${props => props.theme?.cart_icon_color ?? '#393f4f'};
            font-family: 'porto';
            font-size: 1.4rem;
            line-height: 1;
            content: '\\e81c';
        }

        @media (max-width: 991px) {
            /* &:before, */
            i {
                /* font-size: 2.6rem; */
            }
        }

        @media (max-width: 767px) {
            padding-right: 1.5rem;
            /* &:before, */
            i {
                /* font-size: 2.3rem; */
            }
        }

        @media (max-width: 775px) {
            display: ${props => props.theme?.active_icon_cart === false ? 'none' : props.displayMedia};
            background-color: transparent;
            /* &:before, */
                span {
                    display: flex;
                    width: 5px;
                    background-color:red ;
                    box-shadow: 0px;
                    margin-top: ${props => props.theme?.header?.active_icon_cart_circle === true? '-27px' : ''};
                    color: #fff;
                    justify-content: center;

                    span {
                        display: none;
                    }
                }
                h3 {
                    display: none;
                }
                i {
                    color: ${props => props.theme?.header_top?.mobile?.icon_cart_color ?? '#030303'};
                    font-size: ${props => props.theme?.header_top?.mobile?.cart_icon_font_size ?? '2.3rem'};
                    margin-left: ${props => props.theme?.header?.active_icon_cart_circle === true? '-1px' : '10px'};
                    margin-right: 0px;
                    margin-top: ${props => props.theme?.header?.active_icon_cart_circle === true? '-4px' : '0px'};
                }
                &:after {
                    color: ${props => props.theme?.header_top?.mobile?.icon_cart_color ?? '#030303'};
                    display: inline-block;
                }
        }
    }

    &:hover > div ${CDropdownMenu} {
        display: block;
        /* &:before {
            border-color: transparent transparent ${props => props.theme?.header?.menu?.submenu?.background_color ?? '#fff'} transparent;
            border-style: solid;
            border-width: 0 5px 5px 5px;
            content: '';
            height: 0;
            right: 2.1rem;
            position: absolute;
            top: 5px;
            width: 0;
        } */
    }


`;

const propsCDropdownMenu = {
    cartLeft: {
        default: false,
        type: Boolean
    }
}

export const CDropdownMenu = styled('div', propsCDropdownMenu)`
    top: 90%;
    ${props => props.theme?.header?.active_icon_cart_circle === true? (props.theme?.cartLeft?? 'right: -100px') : (props.theme?.cartLeft? 'left:0' : 'right:0')}
    width: 300px;
    padding-top: 9px;
    font-size: 1.1rem;
    color: #777;
    border: 0;
    margin: 0;
    background-color: transparent;
    box-shadow: none;
    display: none;
    transition: all .25s;

    position: absolute;
    z-index: 999;
    @media (max-width: 360px) {
        width: 260px;
    }

    @media (max-width: 775px) {
        ${props => props.cartLeft == true ? 'left: 0;' : 'right: 0;'}
    }
`

export const CDropdownCartActions = styled.div`
    flex-direction: column;
    border-top: 1px solid ${props => props.theme?.cart?.internal_border_color ?? '#e6ebee'};

    .dropdown-cart-clean-cart {
        display: block;
        width: 100%;
        text-align: right;
        padding: 0.5rem 0;

        span {
            cursor: pointer;
            font-size: 1.3rem;
            font-weight: 500;
            text-transform: ${props => props.theme?.cart?.title?.text_transform ?? 'uppercase'};
            color: ${props => props.theme?.cart?.title?.color ?? '#474747'};

            &:hover {
                text-decoration: underline;
            }
        }
    }
`;
